import { Injectable } from '@angular/core';
import { CONTACT_TYPE, ContactService } from '@cemex-core/cmx-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { OneClickOrdersActionTypes, OneClickSelectOrderAction } from '../actions/one-click-orders.actions';
import { of } from 'rxjs';
import { IContactResponse } from '@cemex-core/cmx-api/models/contact/contact-response.interface';
import {
  OneClickLoadReceivingPeopleAction,
  OneClickLoadReceivingPeopleCompleteAction,
  OneClickLoadReceivingPeopleErrorAction,
  OneClickReceivingPeopleActionTypes,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-receiving-persons.actions';

@Injectable()
export class OneClickReceivingPersonEffects {
  loadPaymentsCommand = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickOrdersActionTypes.SELECT_ORDER),
      map((action: OneClickSelectOrderAction) => {
        return new OneClickLoadReceivingPeopleAction(action.payload);
      }),
    ),
  );

  paymentTermsLoadFromProduct = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickReceivingPeopleActionTypes.LOAD_RECEIVING_PEOPLE),
      map((action: OneClickLoadReceivingPeopleAction) => action.payload),
      filter((order) => !!order),
      switchMap((order) => {
        return this.contactService
          .getJobsiteContacts({
            customerId: order.customer.customerId,
            jobsiteId: order.jobsite.jobsiteId,
            contactType: [CONTACT_TYPE.JOBSITE, CONTACT_TYPE.CUSTOMER],
          })
          .pipe(
            map((response: IContactResponse) => {
              return new OneClickLoadReceivingPeopleCompleteAction(response.contacts);
            }),
            catchError((error) => of(new OneClickLoadReceivingPeopleErrorAction(error))),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private contactService: ContactService,
  ) {}
}
